import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SewWsButton } from '@sew/ui-components-angular/standalone';
import { CustomBreakpoint } from '../../../../helpers/breakpoint.helper';
import { getImageResolution } from '../../../../helpers/image.helper';
import { Content } from '../../../../models/blog-posts.model';
import { TruncatePipe } from '../../../../pipes/truncate/truncate.pipe';

@Component({
    selector: 'blog-cta',
    templateUrl: './cta.component.html',
    styleUrls: ['./cta.component.scss'],
    imports: [CommonModule, TruncatePipe, SewWsButton],
})
export class CtaComponent implements OnInit, OnChanges {
    @Input() public cta?: Content;
    @Input() public breakpoint?: CustomBreakpoint;

    public imgUrl?: string;

    public ngOnInit(): void {
        this.init();
    }

    public ngOnChanges(): void {
        if (this.breakpoint && this.breakpoint >= 0) {
            this.init();
        }
    }

    public btnClicked(): void {
        if (!this.cta) {
            return;
        }
        window.location.href = this.cta.link;
    }

    private init(): void {
        this.imgUrl = `url(${this.getImg()})`;
    }

    private getImg(): string {
        if (!this.cta || this.breakpoint === undefined) {
            return '';
        }

        return getImageResolution(this.cta.src, this.breakpoint);
    }
}
